import type { HttpPost } from '@/shared/infra/http'
import { HttpError } from '@/shared/infra/http'
import { IdentityDocumentUploadError } from '@/shared/domain'
import type {
  IdentityDocumentType,
  UploadIdentityDocument,
  UploadIdentityDocumentParams,
  UploadIdentityDocumentResult,
} from '@/modules/auth/use-cases'

type RawDocument = {
  id?: string
  documentType?: string
  issuingState?: string
  hasDocument?: boolean
}

type RawResponse = {
  document?: RawDocument
}

export class EdgeUploadIdentityDocumentRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: UploadIdentityDocument = async (
    params: UploadIdentityDocumentParams,
  ): Promise<UploadIdentityDocumentResult> => {
    try {
      const response = await this.httpClient.post<
        UploadIdentityDocumentParams,
        RawResponse
      >({
        url: '/users/identity-documents',
        body: {
          documentType: params.documentType,
          issuingState: params.issuingState,
          documentNumber: params.documentNumber,
          expiry: params.expiry,
          file: params.file,
          contentType: params.contentType,
        },
      })

      const document = response?.document ?? {}
      return {
        id: document.id ?? '',
        documentType: (document.documentType ?? params.documentType) as IdentityDocumentType,
        issuingState: document.issuingState ?? params.issuingState,
        hasDocument: document.hasDocument === true,
      }
    } catch (error) {
      if (error instanceof HttpError && error.status >= 400 && error.status < 500) {
        throw new IdentityDocumentUploadError(readErrorMessage(error.body))
      }
      throw error
    }
  }
}

function readErrorMessage(body: unknown): string | undefined {
  if (typeof body !== 'object' || body === null) return undefined
  const error = (body as { error?: unknown }).error
  return typeof error === 'string' ? error : undefined
}
